// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"1580894c","62":"e8c12537","74":"99c3d0c0","158":"af58296e","267":"44faa774","312":"a73f90d2","388":"474b59c9","451":"2f1171fb","470":"0032d592","711":"90e49f85","752":"d355ef1c","971":"fad2f363","983":"fa9337c1"}[chunkId] + ".chunk.js";
};